import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FeatherIcon from "feather-icons-react";
import { OverlayPanel } from "primereact/overlaypanel";
import { Dropdown } from "primereact/dropdown";
import UIButton from "src/components/UI/Button";
import { useToast } from "src/components/Common/ReactToaster";
import { getJobPrefixLoading } from "src/store/actions";
import { clearJobsheetTatMessage, getJobPrefixExcelLoading } from "src/store/jobsheetTat/action";
import { RootReducerState } from "src/store/reducers";

const ManufacturerPrefixReport = () => {
    const dispatch = useDispatch();
    const { showToast } = useToast();
    const overlayRef = useRef<OverlayPanel>(null);

    const [selectedPrefix, setSelectedPrefix] = useState<string>("");

    const { jobPrefixList } = useSelector(
        (state: RootReducerState) => state.dashboard
    );
    const { loading, message } = useSelector(
        (state: RootReducerState) => state.jobsheetTatReducer
    );

    // Fetch prefix list on mount
    useEffect(() => {
        dispatch(getJobPrefixLoading());
    }, []);

    // Show success toast when mail is sent and reset selection
    useEffect(() => {
        if (message) {
            showToast(message, { type: "success" });
            setSelectedPrefix("");  // clear selection after successful send
            setTimeout(() => {
                dispatch(clearJobsheetTatMessage());
            }, 1000);
        }
    }, [message]);

    const prefixOptions = useMemo(() => {
        return (
            jobPrefixList?.map((item: any) => ({
                label: item.jobPrefix,
                value: item.jobPrefix,
            })) || []
        );
    }, [jobPrefixList]);

    const handleSendMail = () => {
        if (selectedPrefix) {
            dispatch(getJobPrefixExcelLoading(selectedPrefix));
            overlayRef.current?.hide();
        }
    };

    return (
        <>
            {/* Trigger button — text + icon */}
            <button
                type="button"
                className="btn header-item d-flex align-items-center gap-1"
                title="Send Prefix Report"
                onClick={(e) => overlayRef.current?.toggle(e)}
                style={{
                    padding: "4px 10px",
                    height: "auto",
                    whiteSpace: "nowrap",
                    fontSize: "13px",
                    fontWeight: 500,
                    border: "1.5px solid #ced4da",
                    borderRadius: "6px",
                    margin: "auto 4px",
                    cursor: "pointer",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = "#556ee6"; (e.currentTarget as HTMLElement).style.boxShadow = "0 0 0 2px rgba(85,110,230,0.15)"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = "#ced4da"; (e.currentTarget as HTMLElement).style.boxShadow = "none"; }}
            >
                <FeatherIcon icon="mail" style={{ width: "16px", height: "16px" }} />
                <span>Send Prefix Mail</span>
            </button>

            {/* PrimeReact OverlayPanel popover */}
            <OverlayPanel ref={overlayRef} style={{ width: "240px" }}>
                <div className="mb-3">
                    <label
                        htmlFor="manufacturer-prefix-dropdown"
                        style={{ fontSize: "13px", fontWeight: 600, marginBottom: "6px", display: "block" }}
                    >
                        Job Prefix
                    </label>
                    <Dropdown
                        inputId="manufacturer-prefix-dropdown"
                        value={selectedPrefix}
                        onChange={(e) => setSelectedPrefix(e.value)}
                        options={prefixOptions}
                        optionLabel="label"
                        placeholder="-- Select Prefix --"
                        className="w-full"
                        style={{ width: "100%" }}
                    />
                </div>

                <div className="p-column-filter-buttonbar">
                    <UIButton
                        label="Clear"
                        className="secondary-btn"
                        type="button"
                        onClick={() => setSelectedPrefix("")}
                    />
                    <UIButton
                        label="Send Mail"
                        className="btn-primary"
                        type="button"
                        onClick={handleSendMail}
                        disabled={(loading || (!selectedPrefix))}
                    />
                </div>
            </OverlayPanel>
        </>
    );
};

export default ManufacturerPrefixReport;
